module.exports = __webpack_public_path__ + "img/snow_4ee71c990.png";